const requiredEnv = {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    REACT_APP_DOCUMENTALE_URL: process.env.REACT_APP_DOCUMENTALE_URL,
    REACT_APP_BASE_FILE_URL: process.env.REACT_APP_BASE_FILE_URL,
    REACT_APP_BASE_THUMBNAIL_URL: process.env.REACT_APP_BASE_THUMBNAIL_URL,
} as const;

const missingEnv = Object.entries(requiredEnv)
    .filter(([, value]) => !value)
    .map(([key]) => key);

if (missingEnv.length > 0) {
    throw new Error(`Missing required environment variables: ${missingEnv.join(", ")}`);
}

export const env = requiredEnv as Record<keyof typeof requiredEnv, string>;

export const optionalEnv = {
    workInProgress: ["1", "true", "yes"].includes((process.env.REACT_APP_WORK_IN_PROGRESS ?? "").toLowerCase()),
} as const;
